"use script";

angular.module("customer")
.constant("INVENTORY_SYNC_QUEUE_START_MS_DELAY", 2000);



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/vendor-inventory-external-sync/vendor-inventory-external-sync.constant.js
// module id = 875
// module chunks = 0